import styled from "styled-components";
import { TakeOrderData } from "../../proto/nbchat-proto";

const Card = styled.div`
  background: #fff;
  border-radius: 10px;
  padding: 12px 15px;
  margin: 10px 15px;
  cursor: pointer;
`;

const Row = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 2px 0;
`;

const Label = styled.span`
  flex-shrink: 0;
  font-size: 14px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.text};
`;

const Value = styled.span`
  flex: 1;
  font-size: 13px;
  color: ${({ theme }) => theme.colors.secondaryText || "#999"};
  line-height: 20px;
  word-break: break-all;
`;

const Status = styled.span<{ $color: string }>`
  flex-shrink: 0;
  margin-left: 8px;
  font-size: 14px;
  color: ${({ $color }) => $color};
`;

const formatTime = (value?: string) => {
  if (!value) return "-";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(
    d.getHours()
  )}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
};

const ComplaintCard = ({
  order,
  onClick,
}: {
  order: TakeOrderData;
  onClick?: () => void;
}) => {
  const pending = order.status === 10;
  return (
    <Card onClick={onClick}>
      <Row>
        <Label>订单号：</Label>
        <Value>{order.trans_no}</Value>
        <Status $color={pending ? "#ED860E" : "#33C341"}>
          {pending ? "待处理" : "已处理"}
        </Status>
      </Row>
      <Row>
        <Label>申诉原因：</Label>
        <Value>{order.options?.dispute_reason || ""}</Value>
      </Row>
      <Row>
        <Label>申诉时间：</Label>
        <Value>{formatTime(order.disputed_at)}</Value>
      </Row>
    </Card>
  );
};

export default ComplaintCard;
